import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-collection-calculation',
  templateUrl: './collection-calculation.component.html',
  styleUrls: ['./collection-calculation.component.css']
})
export class CollectionCalculationComponent implements OnInit {
    public grid?: GridOptions;

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_collectioncalculation.grid')
                .setLoadDataFunction({ method: 2781 })
                .setKendoConfig({ height: '100%' })
                .setToolbar({
                    pdfExport: false,
                    excelExport: false,
                    layouts: false,
                    wrapping: true
                });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
